import _css from "@emotion/css";
import { jsx as ___EmotionJSX } from "@emotion/core";

/** @jsx jsx */
import { jsx } from '@emotion/core';
import { borderRadius } from '@atlaskit/theme';
var BORDER_RADIUS = "".concat(borderRadius(), "px");
export default (function (_ref) {
  var backgroundColor = _ref.backgroundColor,
      textColor = _ref.textColor,
      children = _ref.children;
  return jsx("span", {
    css:
    /*#__PURE__*/
    _css({
      backgroundColor: backgroundColor,
      borderRadius: BORDER_RADIUS,
      boxSizing: 'border-box',
      color: textColor,
      display: 'inline-block',
      fontSize: '11px',
      fontWeight: 700,
      lineHeight: 1,
      maxWidth: '100%',
      padding: '2px 0 3px 0',
      textTransform: 'uppercase',
      verticalAlign: 'baseline'
    }, process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uL3NyYy9Mb3plbmdlL0NvbnRhaW5lci5qcyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFtQkkiLCJmaWxlIjoiLi4vc3JjL0xvemVuZ2UvQ29udGFpbmVyLmpzIiwic291cmNlc0NvbnRlbnQiOlsiLy8gQGZsb3dcbi8qKiBAanN4IGpzeCAqL1xuaW1wb3J0IHsgdHlwZSBOb2RlIH0gZnJvbSAncmVhY3QnO1xuaW1wb3J0IHsganN4IH0gZnJvbSAnQGVtb3Rpb24vY29yZSc7XG5pbXBvcnQgeyBib3JkZXJSYWRpdXMgfSBmcm9tICdAYXRsYXNraXQvdGhlbWUnO1xuaW1wb3J0IHsgdHlwZSBUaGVtZVRva2VucyB9IGZyb20gJy4uL3RoZW1lJztcblxuY29uc3QgQk9SREVSX1JBRElVUyA9IGAke2JvcmRlclJhZGl1cygpfXB4YDtcblxudHlwZSBUaGVtZVRva2Vuc1dpdGhDaGlsZHJlbiA9IFRoZW1lVG9rZW5zICYge1xuICBjaGlsZHJlbj86IE5vZGUsXG59O1xuXG5leHBvcnQgZGVmYXVsdCAoe1xuICBiYWNrZ3JvdW5kQ29sb3IsXG4gIHRleHRDb2xvcixcbiAgY2hpbGRyZW4sXG59OiBUaGVtZVRva2Vuc1dpdGhDaGlsZHJlbikgPT4gKFxuICA8c3BhblxuICAgIGNzcz17e1xuICAgICAgYmFja2dyb3VuZENvbG9yLFxuICAgICAgYm9yZGVyUmFkaXVzOiBCT1JERVJfUkFESVVTLFxuICAgICAgYm94U2l6aW5nOiAnYm9yZGVyLWJveCcsXG4gICAgICBjb2xvcjogdGV4dENvbG9yLFxuICAgICAgZGlzcGxheTogJ2lubGluZS1ibG9jaycsXG4gICAgICBmb250U2l6ZTogJzExcHgnLFxuICAgICAgZm9udFdlaWdodDogNzAwLFxuICAgICAgbGluZUhlaWdodDogMSxcbiAgICAgIG1heFdpZHRoOiAnMTAwJScsXG4gICAgICBwYWRkaW5nOiAnMnB4IDAgM3B4IDAnLFxuICAgICAgdGV4dFRyYW5zZm9ybTogJ3VwcGVyY2FzZScsXG4gICAgICB2ZXJ0aWNhbEFsaWduOiAnYmFzZWxpbmUnLFxuICAgIH19XG4gID5cbiAgICB7Y2hpbGRyZW59XG4gIDwvc3Bhbj5cbik7XG4iXX0= */")
  }, children);
});